// utils/strapiMedia.js
export const getStrapiMedia = (media) => {
  if (!media[0]?.url) return null
  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337"

  return `${STRAPI_URL}${media[0]?.url}`
}
